import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  image
}: TestimonialCardProps) {
  return <div className="bg-zinc-900 p-6 rounded-lg border border-zinc-800 hover:border-zinc-700 transition-colors" data-id="element-303">
      <div className="flex gap-1 mb-4" data-id="element-304">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-305" />)}
      </div>

      <p className="text-zinc-300 text-sm leading-relaxed mb-6 italic" data-id="element-306">
        "{content}"
      </p>

      <div className="flex items-center gap-3" data-id="element-307">
        <div className="w-10 h-10 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-zinc-400 font-bold" data-id="element-308">
          {image ? <img src={image} alt={name} className="w-full h-full object-cover rounded-full" data-id="element-309" /> : name[0]}
        </div>
        <div data-id="element-310">
          <div className="text-white font-bold text-sm" data-id="element-311">{name}</div>
          <div className="text-zinc-500 text-xs" data-id="element-312">{role}</div>
        </div>
      </div>
    </div>;
}